var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Нажаль, таку сторінку не знайдено")]),_c('v-card-text',[_c('div',[_vm._v("Але можемо повернути вас на"),_c('router-link',{staticClass:"ml-5",attrs:{"to":"/"}},[_vm._v("головну")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }